
import { defineComponent, ref } from "vue";
import Profile from "@/helpers/pages/Profile";
import AgCard from "@/components/ag-card/index.vue";
import { useStore } from "@/store";
import apiIdentity from "@/store/axiosIdentity";
import { notify } from "@kyvg/vue3-notification";
import Swal from "sweetalert2";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "Profile",
  data() {
    return {
      module: Profile,
    };
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    let currentPassword = ref("");
    let newPassword = ref("");
    const userId = store.state.auth.user.filter((item) => item.type == "uid")[0]
      .value;

    const submitFunction = async (e: any) => {
      const data = {
        userId,
        currentPassword: currentPassword.value,
        newPassword: newPassword.value,
      };

      try {
        const res = await apiIdentity.post("/ChangePassword", data);
        if (res) {
          if (res.data.statusCode != 200) {
            let msg = res.data.message;
            msg += "<br>";
            msg += res.data.errors.join("<br>");
            Swal.fire("Error", msg, "error");
          } else {
            router.back()
            notify({
              title: "The password was changed!",
              type: "success",
              duration: 4000,
            });
          }
        }
      } catch (error) {
        notify({
          title: "An unexpected error has occurred!",
          type: "error",
          duration: 4000,
        });
      }
    };

    return {
      submitFunction,
      currentPassword,
      newPassword,
    };
  },
  components: { AgCard },
});
